import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: "80px 24px", textAlign: "center" }}>
          <p style={{ fontFamily: "Cormorant Garamond, serif", fontSize: 28 }}>
            Something went wrong.
          </p>
          <a href="/" style={{ color: "#9A792F" }}>
            Return to Sashti Jewels
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
